export default __webpack_public_path__ + "static/media/bin.7d20b514.svg";